import { Box, Flex, Heading } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { updateProjectStatus } from "store/customerProject/reducer";
import { uploadProjectSelector } from "store/customerProject/selector";
import StepShell from "../components/StepShell";
import SelectionRadio from "../components/SelectionRadio";

function ServiceCard(props: {
  title: string;
  description: string;
  selected: boolean;
  onClick: () => void;
}) {
  const { title, description, selected, onClick } = props;

  return (
    <Box
      borderRadius="12px"
      border={`1px solid ${selected ? "#3A7BFF" : "#E6ECF3"}`}
      bg={selected ? "#F5F9FF" : "#FFFFFF"}
      p="16px"
      cursor="pointer"
      onClick={onClick}
    >
      <Flex alignItems="flex-start" gap="16px">
        <SelectionRadio checked={selected} />
        <Box flex="1" minW="0">
          <Heading fontSize="16px" fontWeight="600" color="#0B0E10" mb="6px">
            {title}
          </Heading>
          <Box
            fontSize="14px"
            fontWeight="500"
            color="#0B0E10"
            lineHeight="1.4"
          >
            {description}
          </Box>
        </Box>
      </Flex>
    </Box>
  );
}

export default function Step1Service(props: { onNext: () => void }) {
  const { onNext } = props;
  const uploadProject = useSelector(uploadProjectSelector);
  const dispatch = useDispatch();

  return (
    <StepShell
      step={1}
      title="Place your order"
      description="Provide your details to get started quickly."
      primaryLabel="Continue"
      onPrimary={onNext}
    >
      <Box borderRadius="12px" bg="#F5F7FA" p="24px" border="1px solid #E6ECF3">
        <Heading fontSize="18px" fontWeight="600" color="#0B0E10" mb="16px">
          Translation Service
        </Heading>
        <Flex direction="column" rowGap="16px">
          <ServiceCard
            title="Certified translation"
            description="A word-for-word translation with a signed certificate for official purposes like immigration or education."
            selected={uploadProject.transitionType === "certified"}
            onClick={() => {
              dispatch(
                updateProjectStatus({
                  transitionType: "certified",
                  include_desktop_publishing: false,
                  include_proofreading: false,
                }),
              );
            }}
          />
          <ServiceCard
            title="Standard translation"
            description="A translation for business or individual use, delivered in an editable Word document with no certificate."
            selected={uploadProject.transitionType === "standard"}
            onClick={() => {
              dispatch(
                updateProjectStatus({
                  transitionType: "standard",
                  isMailHardCopy: false,
                  isNotarized: false,
                  include_expedited_turnaround: false,
                  address: "",
                  include_desktop_publishing: false,
                  include_proofreading: false,
                }),
              );
            }}
          />
        </Flex>
      </Box>
    </StepShell>
  );
}
